import { makeAutoObservable } from 'mobx';
import type { IconNamesType } from 'ksnm-common-ui/lib/Icon/types';
import type { ReactElement } from 'react';

export interface ConfirmDialogStoreProps {
  title?: string;
  text?: string | ReactElement;
  visible?: boolean;
  onOk: () => void;
  onCancel?: () => void;
  width?: number;
  iconType?: IconNamesType;
  iconFill?: string;
  onClose?: () => void;
}

const noop = (): void => {};

export class ConfirmDialogStore implements ConfirmDialogStoreProps {
  title?: string;

  width?: number;

  text?: string | ReactElement;

  visible = false;

  iconType?: IconNamesType;

  iconFill?: string;

  onClose?: () => void = noop;

  onOk = noop;

  onCancel?: () => void = noop;

  constructor() {
    makeAutoObservable(this);
  }

  open = (props: ConfirmDialogStoreProps): void => {
    const { title, text, onOk, onCancel, width, onClose, iconType, iconFill } = props;

    this.title = title;
    this.text = text;
    this.onOk = onOk;
    this.onCancel = onCancel;
    this.visible = true;
    this.width = width;
    this.iconType = iconType;
    this.iconFill = iconFill;
    this.onClose = onClose;
  };

  close = (): void => {
    this.onClose?.();
    this.visible = false;
    this.title = undefined;
    this.text = undefined;
    this.iconType = undefined;
    this.iconFill = undefined;
    this.onOk = noop;
    this.onCancel = noop;
    this.onClose = noop;
  };

  confirm = (): void => {
    this.onOk();
    this.close();
  };

  cancel = (): void => {
    this.onCancel?.();
    this.close();
  };
}

export const confirmDialogStore = new ConfirmDialogStore();
